import { defineComponent as C, useSlots as w, ref as p, computed as u, watch as m, withDirectives as S, openBlock as a, createElementBlock as n, normalizeClass as h, createElementVNode as d, createBlock as B, resolveDynamicComponent as P, withCtx as V, createTextVNode as $, toDisplayString as D, createCommentVNode as i, renderSlot as y, unref as k } from "vue";
import { B as L } from "./BodyScrollLock.f247d772.js";
import '../assets/index45.css';const H = "Escape", N = (t, s) => {
  s.key === H && t != null && t();
}, A = {
  beforeMount(t, s) {
    if (typeof s.value != "function")
      throw new Error(
        "[directive:on-escape] The binding value must be a function"
      );
    const e = N.bind(null, s.value);
    t.__escapePressHandler__ = e, document.addEventListener("keyup", e);
  },
  updated(t, s) {
    s.arg === "disable" ? document.removeEventListener("keyup", t.__escapePressHandler__) : t.__escapePressHandler__ && document.addEventListener("keyup", t.__escapePressHandler__);
  },
  beforeUnmount(t) {
    document.removeEventListener("keyup", t.__escapePressHandler__);
  }
}, F = ["data-event"], K = { class: "Modal__container" }, T = { class: "Modal__header" }, U = ["data-event"], z = { class: "Modal__body" }, Y = {
  key: 0,
  class: "Modal__spacer"
}, j = ["data-event"], J = /* @__PURE__ */ C({
  __name: "Modal",
  props: {
    title: { default: "Subscribe" },
    show: { type: Boolean, default: !1 },
    forceShow: { type: Boolean, default: !0 },
    position: { default: "fixed" },
    skin: { default: "normal" },
    heading: { default: "h3" }
  },
  emits: ["close"],
  setup(t, { emit: s }) {
    const e = t, b = L, g = A, _ = w(), M = p(!1), r = p(!1), E = u(() => {
      const o = ["Modal"];
      return e.position === "absolute" && o.push(`Modal--${e.position}`), r.value && o.push("Modal--show"), v.value || o.push("Modal--noFooter"), e.skin === "floatingClose" && o.push(`Modal--${e.skin}`), o;
    }), v = u(() => !!_.footer && _.footer().length > 0), c = u(() => e.skin === "floatingClose"), l = () => {
      r.value = !1, s("close");
    }, f = () => {
      r.value = !0;
    };
    return m(
      () => e.forceShow,
      () => {
        f();
      }
    ), m(
      () => e.show,
      () => {
        e.show && f(), e.show || l();
      }
    ), (o, q) => S((a(), n("div", {
      class: h(E.value)
    }, [
      d("button", {
        "aria-label": "Close modal",
        class: "Modal__overlay",
        onClick: l,
        "data-event": o.$ga.getDataEventValue("modal", "overlay", "close")
      }, null, 8, F),
      d("div", K, [
        d("div", T, [
          (a(), B(P(o.heading), { class: "Modal__title" }, {
            default: V(() => [
              $(D(o.title), 1)
            ]),
            _: 1
          })),
          c.value ? i("", !0) : (a(), n("button", {
            key: 0,
            "aria-label": "Close modal",
            class: "Modal__close",
            onClick: l,
            "data-event": o.$ga.getDataEventValue("modal", "button", "close")
          }, null, 8, U))
        ]),
        d("div", z, [
          y(o.$slots, "body"),
          c.value ? (a(), n("div", Y)) : i("", !0)
        ]),
        v.value ? (a(), n("div", {
          key: 0,
          class: h(["Modal__footer", { "Modal__footer--multiple": M.value }])
        }, [
          y(o.$slots, "footer")
        ], 2)) : i("", !0),
        c.value ? (a(), n("button", {
          key: 1,
          "aria-label": "Close modal",
          class: "Modal__floatingClose",
          onClick: l,
          "data-event": o.$ga.getDataEventValue("modal", "button", "close")
        }, null, 8, j)) : i("", !0)
      ])
    ], 2)), [
      [k(b), r.value],
      [k(g), l]
    ]);
  }
});
export {
  A as E,
  J as _
};
